import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Estacao} from '../models/estacao.model';
import {AbstractService} from './abstract.service';
import {SocialSharing} from '@awesome-cordova-plugins/social-sharing/ngx';
import {LoadingController, Platform} from '@ionic/angular';

import * as htmlToImage from 'html-to-image';

@Injectable({
  providedIn: 'root'
})
export class EstacaoService extends AbstractService<Estacao> {

  constructor(
    http: HttpClient,
    private platform: Platform,
    private socialSharing: SocialSharing,
    private loadingController: LoadingController) {

    super('v1/estacao', http);
  }

  public estacoesProximas(lat: string, lng: string): Observable<Estacao[]> {
    return this.getAll(`proximas?lat=${lat}&lng=${lng}`);
  }

  public buscarPorIds(ids: string): Observable<Estacao[]> {
    return this.getAll(`por-ids?ids=${ids}`);
  }

  public estacaoMaisProxima(lat: string, lng: string): Observable<Estacao> {
    return this.getOne(`maisProxima?lat=${lat}&lng=${lng}`);
  }

  protected extractListData(res: any): Array<Estacao> {
    const arrRes = [];
    const body: any = res;
    if (body && body.length) {
      // @ts-ignore
      body.forEach(e => arrRes.push(e));
    }
    return arrRes;
  }

  async compartilhar(estacao: Estacao, elementId: string, height = 0) {

    const loading = await this.loadingController.create({
      cssClass: 'loading-monitorar',
      spinner: 'dots',
      mode: 'ios',
      backdropDismiss: true
    });

    await loading.present();

    const element = document.getElementById(elementId);
    const options = {backgroundColor: 'white', width: element.clientWidth, height: element.clientHeight + 50};

    htmlToImage.toCanvas(element, options).then(async (canvas) => {

      this.crop(canvas, 0, 0, element.clientWidth + 10, element.clientHeight + 10 + height, async (dataUrl) => {
        if (this.platform.is('hybrid')) {
          this.socialSharing.share('', '', dataUrl)
            .then(async () => await this.loadingController.dismiss())
            .catch(async () => await this.loadingController.dismiss());
        } else {
          let linkEl = document.createElement('a');
          linkEl.download = estacao.noEstacao + '.jpg';
          linkEl.href = dataUrl;
          document.body.appendChild(linkEl);
          linkEl.click();
          document.body.removeChild(linkEl);
          linkEl = null;

          await this.loadingController.dismiss();
        }
      });
    });
  }

  private crop(canvas, offsetX, offsetY, width, height, callback) {

    const buffer = document.createElement('canvas');
    const ctx = buffer.getContext('2d');

    buffer.width = width;
    buffer.height = height;

    ctx.drawImage(canvas, offsetX, offsetY, width, height, 0, 0, buffer.width, buffer.height);

    callback(buffer.toDataURL());
  }

  protected extractData(res: any): Estacao {
    const body: any = res;
    if (body) {
      return body as Estacao;
    }
    return null;
  }

}
